import { Action } from '@ngrx/store';

import { Country } from '~shared/models';

export enum CountriesActionTypes {
  READ_COUNTRIES = '[app-checkout/Checkout] Read countries',
  READ_COUNTRIES_SUCCESS = '[app-checkout/Checkout] Read countries Success',
  READ_COUNTRIES_FAILURE = '[app-checkout/Checkout] Read countries Failure',
}

export class ReadCountries implements Action {
  readonly type = CountriesActionTypes.READ_COUNTRIES;
}

export class ReadCountriesSuccess implements Action {
  readonly type = CountriesActionTypes.READ_COUNTRIES_SUCCESS;
  constructor(public payload: Country[]) {}
}

export class ReadCountriesFailure implements Action {
  readonly type = CountriesActionTypes.READ_COUNTRIES_FAILURE;
  constructor(public payload: any) {}
}

export type CountriesActions = ReadCountries | ReadCountriesSuccess | ReadCountriesFailure;
